<template>
  <div class="layout">
    <!-- Global loading indicator -->
    <LoadingIndicator ref="loader" />

    <nav class="navbar navbar-expand-lg" v-if="!isFullScreen">
      <div class="container">
        <router-link class="navbar-brand" to="/">Reliance Health Solutions</router-link>
        <button class="navbar-toggler" type="button" @click="toggleMenu">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" v-bind:class="{ show: menuOpen }">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item"><router-link class="nav-link" to="/">Home</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/about">About</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/services">Services</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/contact">Contact</router-link></li>
            <li class="nav-item" v-if="!isLoggedIn"><router-link class="nav-link" to="/login">Login</router-link></li>
            <li class="nav-item" v-if="isLoggedIn"><router-link class="nav-link" to="/dashboard">Dashboard</router-link>
            </li>
            <li class="nav-item" v-if="isLoggedIn"><a class="nav-link" @click="logout()">Logout</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <main class="main-content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>

    <footer class="footer" v-if="!isFullScreen">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <h5>Reliance Health Solutions</h5>
            <p>Compassionate care and professional rehabilitation services for lasting recovery.</p>
          </div>
          <div class="col-md-4">
            <h5>Quick Links</h5>
            <ul class="footer-links">
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">About</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
          <div class="col-md-4">
            <h5>Contact Info</h5>
            <p>Email: info@reliancehealth.com<br>Phone: (555) 123-4567</p>
          </div>
        </div>
        <div class="footer-bottom text-center mt-4">
          <p>&copy; 2025 Reliance Health Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import emitter from '@/eventBus';
import LoadingIndicator from '@/components/LoadingIndicator.vue';

export default {
components: {
    LoadingIndicator
  },
  data() {
    return {
      menuOpen: false,
      isFullScreen: false
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    }
    ,
    handleToggleFullscreen() {
      this.isFullScreen = this.$store.getters.isFullScreen;
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
  provide() {
    return {
      loader: this.$refs.loader
    };
  },
  watch: {
    "$route"(to) {
      if (this.isLoggedIn && to.path === '/login') {
        this.$router.push('/dashboard');
      }
    }
  },

  mounted() {
    emitter.on('toggle-fullscreen', this.handleToggleFullscreen);
    this.isFullScreen = this.$store.getters.isFullScreen;
     this.$nextTick(() => {
      window.appLoader = this.$refs.loader;
    });
  }

};
</script>

<style>
/* Ensure full page height */
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.signature-font {
  font-family: 'Pacifico', cursive;
  font-size: 1.2rem;
}

.signature-font-lg {
  font-family: 'Pacifico', cursive;
  font-size: 2rem;
}

/* Content expands to push footer down */
.main-content {
  flex: 1;
}

/* Footer stays at the bottom */
.footer {
  background-color: #1a1a2e;
  color: #fff;
  padding: 40px 0 20px;
  font-size: 14px;
  position: relative;
  width: 100%;
  margin-top: auto;
}

.footer h5 {
  color: #4a90e2;
  font-weight: 600;
  margin-bottom: 20px;
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #ddd;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #4a90e2;
}

.footer-bottom {
  border-top: 1px solid #333;
  padding-top: 20px;
  margin-top: 20px;
}

/* Navigation Bar */
.navbar {
  background-color: #1a1a2e;
  padding: 15px 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.navbar-brand {
  color: white !important;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.nav-link {
  color: #ddd !important;
  cursor: pointer;
  margin: 0 10px;
  font-weight: 500;
  transition: color 0.3s;
  position: relative;
}

.nav-link:hover {
  color: #4a90e2 !important;
}

.nav-link.router-link-active {
  color: #4a90e2 !important;
}
#app {
  font-family: 'Roboto', Arial, sans-serif;
}
</style>